/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Modal } from '@carbon/react';
import { observer } from 'mobx-react';

import { CloudProcess } from 'icons';
import { clusterCreationModalStore } from 'features/create-cluster/index';

import { Content, InnerContent, Message, Title, Visual, Wrapper } from './ClusterCreationModal.styled';

const ClusterCreationModal = ({ title, subtitle, onClose = () => {} }) => {
  const { isVisible, close } = clusterCreationModalStore;
  const onRequestClose = () => {
    close();
    onClose();
  };

  return (
    <Wrapper>
      <Modal open={isVisible} onRequestClose={() => onRequestClose()} passiveModal>
        <Content>
          <Visual>
            <CloudProcess />
          </Visual>

          <InnerContent>
            <Title>{title}</Title>

            <Message>{subtitle}</Message>
          </InnerContent>
        </Content>
      </Modal>
    </Wrapper>
  );
};

export default observer(ClusterCreationModal);
